module.exports = __webpack_public_path__ + "img/bank-transfer.49e610b4.png";